import { render, staticRenderFns } from "./Endchallenge.vue?vue&type=template&id=e20330fc&scoped=true&"
import script from "./Endchallenge.vue?vue&type=script&lang=js&"
export * from "./Endchallenge.vue?vue&type=script&lang=js&"
import style0 from "./Endchallenge.vue?vue&type=style&index=0&id=e20330fc&lang=scss&scoped=true&"
import style1 from "./Endchallenge.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e20330fc",
  null
  
)

export default component.exports